<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-二手车-添加
    -->
  <el-dialog
    title="添加二手车"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >
    <div class="product-add pb50">
      <el-form
        size="small"
        :model="form"
        ref="form"
        :rules="rules"
        label-width="100px"
      >
       <el-form-item label="名称" prop="title">
          <el-input v-model="form.title" placeholder="请输入名称" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="型号" prop="model">
          <el-input v-model="form.model" placeholder="请输入型号" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="详情" prop="intro">
          <el-input v-model="form.intro" placeholder="请输入详情" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="品牌" prop="brand">
          <el-input v-model="form.brand" placeholder="请输入品牌" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="年份" prop="year">
          <el-input v-model="form.year" placeholder="请输入年份" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="年限" prop="duration">
          <el-input v-model="form.duration" placeholder="请输入年限" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="外观" prop="exterior">
          <el-input v-model="form.exterior" placeholder="请输入外观" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="全车功能测试" prop="fun_test">
          <el-input v-model="form.fun_test" placeholder="请输入全车功能测试" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="电路系统检测" prop="cs_test">
          <el-input v-model="form.cs_test" placeholder="请输入电路系统检测" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="液压泵压力" prop="cp_pressure">
          <el-input v-model="form.cp_pressure" placeholder="请输入液压泵压力" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="发动机缸压" prop="ec_pressure">
          <el-input v-model="form.ec_pressure" placeholder="请输入发动机缸压" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="发动机小时" prop="e_hour">
          <el-input v-model="form.e_hour" placeholder="请输入发动机小时" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="风机小时" prop="wt_hour">
          <el-input v-model="form.wt_hour" placeholder="请输入风机小时" class="max-w460"></el-input>
        </el-form-item>
       

        <el-form-item label="审核状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="0">未审核</el-radio>
            <el-radio :label="1">审核通过</el-radio>
            <el-radio :label="2">审核未通过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="图片：" prop="model.image">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.image">
              <transition-group>
                <div v-for="(item, index) in form.image" :key="item">
                  <div class="item">
                    <img v-img-url="item" alt="item" />
                    <a
                      href="javascript:void(0);"
                      class="delete-btn"
                      @click.stop="deleteImg(index, 'album')"
                      ><i class="el-icon-close"></i
                    ></a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('album')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>


        <el-form-item label="排序" prop="name"
          ><el-input
            v-model="form.sort"
            placeholder="请输入排序"
            class="max-w460"
          ></el-input
        ></el-form-item>

        <!--提交-->
        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc"
            >取消</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="onSubmit"
            :loading="loading"
            >提交</el-button
          >
        </div>
      </el-form>
      <!--商品图片组件-->
      <Upload
        v-if="isProductUpload"
        :config="{ total: 9 }"
        :isupload="isProductUpload"
        @returnImgs="returnProductImgsFunc"
        >上传图片
      </Upload>
      <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
    </div>
  </el-dialog>
</template>

<script>
import UsedCarApi from "@/api/used_car.js";
import Upload from "@/components/file/Upload";
import draggable from "vuedraggable";
export default {
  components: {
    /*图片上传*/
    Upload: Upload,
    draggable,
  },
  data() {
    return {

      selectMap: "1",
      /*是否上传图片*/
      isupload: false,
      isImg: false,
      /*富文本配置*/
      ueditor: {
        text: "",
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        title: "",
        model: "",
        price: "",
        intro: "",
        brand: "",
        year: "",
        exterior: "",
        fun_test: "",
        cs_test: "",
        cp_pressure: "",
        ec_pressure: "",
        e_hour: "",
        wt_hour: "",
        duration:'',
        image: [],
        sort: 50,
      },
      loading: false,
      /*验证规则*/
      rules: {
        
      },
      dialogVisible: false,
      iscategorya: false,
      excludeIds: [],
      isProductUpload: false,
      code: "album"
    };
  },
  created() {
    // console.log(11111)
    this.dialogVisible = this.open_add;
    
  },
  props: ["open_add"],
  methods: {
   
    handleClick(tab, event) {
      console.log(tab, event);
      // this.selectMap = type;
    },

    chooseCategory() {
      this.iscategorya = true;
    },
    /*上传*/
    openUpload(e) {
      this.isupload = true;
    },

    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", { openDialog: false, type: "" });
    },
    cancelFunc() {
      //取消
      this.dialogFormVisible("error");
    },

    onSubmit() {
      let self = this;
      let form = self.form;

      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          UsedCarApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: "success"
              });
              self.dialogFormVisible("error");
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false, type: "" });
    },
    /*打开上传图片*/
    openProductUpload: function(code) {
      this.isProductUpload = true;
      this.code = code;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (this.code == "album") {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          e.forEach(element => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach(e => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          const filePaths = e.map(item => item.file_path);
          let imgs = this.form.image.concat(filePaths);
          this.$set(this.form, "image", imgs);
        }
      } else {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach(element => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach(e => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.bannar.concat(e);
          this.$set(this.form, "bannar", imgs);
        }
      }

      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index, code) {
      if (code == "album") {
        this.form.image.splice(index, 1);
      } else if (code == "bannar") {
        this.form.bannar.splice(index, 1);
      }
    }
  }
};
</script>

<style>
.edit_container {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/used_car/index/part/add.vue